import React from 'react';
import {Box, SxProps} from '@mui/material';
import {Loading} from 'react-admin';

export const LLLoaderComponent: React.FC<{
	isLoading: boolean,
	loaderComponent?: React.ReactElement;
	loaderSx?: SxProps;
	sx?: SxProps;
}> = (
	{isLoading,
		loaderComponent,
		sx,
		loaderSx,
		children
	},
) => {
	return (
		<Box width="100%" sx={sx}>
			{isLoading ? (
				<Box textAlign="center" sx={loaderSx}>
					{loaderComponent || <Loading loadingSecondary={''}/>}
				</Box>
			) : (
				children
			)
			}
		</Box>
	);
};
